<template>
  <div class="baseForm">
    <div class="formDom">
      <Form ref="reviewForm" :dataSource="getBaseForm" id="reviewForm">
        <template v-slot:review_members_new_tip>
          <a-alert
            v-show="checkDisplay('reviewMembersNewTip')"
            style="margin:5px 0 0 10px"
            message="需要输入多评议人的时候，请用分号分割，如：张三；李四"
            type="warning"
            show-icon
          />
        </template>
      </Form>
    </div>
  </div>
</template>

<script>
import Form from '@/components/GlobalForm'
import { forms } from './formData'
export default {
  name: 'ReviewForm',
  components: {
    Form
  },
  props: {
    initData: {
      // 父组件传过来的表单默认值
      type: Object,
      default: () => {
        return {}
      }
    },
    checkDisabled: {
      type: Function,
      default: () => { }
    },
    checkDisplay: {
      type: Function,
      default: () => { }
    },
    pageType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return {
        checkDisabled: this.checkDisabled || (() => { }),
        checkDisplay: this.checkDisplay || (() => { }),
        checkFund: this.checkFund || (() => { })
      }
    },
    getBaseForm() {
      // 获取formData
      return forms.getBaseForm(this._.cloneDeep(this.initData), this.params, this.pageType, this)
    }
  },
  methods: {
    getValue(params) {
      // 获取数据
      const data = this.$refs.reviewForm.getFieldsValue(params)
      return data
    },
    onSubmit(params) {
      // 校验并获取数据
      const data = this.$refs.reviewForm.handleSubmit(params)
      console.log(data)
      return data
    },
    // 是否提交区审批 的change事件
    onChange(value) {
      this.$refs.reviewForm.setFieldsValue('process_config_is_district', value)
      this.$emit('shifouqushenpiChange', value)
    },
    checkFund(value, id) {
      let newValue = value
      newValue = newValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      newValue = newValue
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      setTimeout(() => {
        this.$refs.reviewForm.setFieldsValue(id, newValue)
      }, 0)
    }
  }
}
</script>

<style scoped lang="less">
.formDom {
  /deep/ .ant-alert {
    padding: 5px 5px 5px 35px;
    font-size: 12px;
    .ant-alert-icon {
      top: 8px;
    }
  }
  .show {
    color: #3d73dd;
    cursor: pointer;
  }
  .show:hover {
    color: #4d86ff;
  }
  .personList {
    position: relative;
    border: 1px solid #e8e8e8;
    /deep/ .ant-table-wrapper {
      border-radius: 2px;
    }
    /deep/ .ant-table-placeholder {
      border-bottom: none;
    }
  }
}
</style>
